<mat-progress-bar
  *ngIf="loading" color="accent" mode="indeterminate">
</mat-progress-bar>
